<div class="substitute-dialog-container">
  <!-- Header -->
  <div class="dialog-header">
    <div class="header-icon-wrapper">
      <mat-icon class="header-icon">swap_horiz</mat-icon>
    </div>
    <div class="header-title-group">
      <h2 mat-dialog-title class="dialog-title">Rectification du mode de règlement</h2>
      <p class="dialog-subtitle">Ticket n° {{ data.orderId }} &bull; Remplacement 1 pour 1 obligatoire</p>
    </div>
    <button type="button" class="close-btn" (click)="onCancel()" aria-label="Fermer">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content class="dialog-content">
    <!-- Original Payment Summary Card -->
    <div class="payment-summary-card">
      <div class="card-item">
        <span class="label">Règlement initial</span>
        <span class="value-highlight original-mode">
          {{ originalPayment.methodLabel || 'Mode #' + originalPayment.method }}
        </span>
      </div>
      <div class="card-divider">
        <mat-icon>arrow_forward</mat-icon>
      </div>
      <div class="card-item text-right">
        <span class="label">Montant (inaltéré)</span>
        <span class="value-highlight amount">
          {{ originalPayment.amount | fc }}
        </span>
      </div>
    </div>

    <!-- Error Alert Banner -->
    @if (errorMessage) {
      <div class="alert-banner error" role="alert">
        <mat-icon>error_outline</mat-icon>
        <span class="alert-text">{{ errorMessage }}</span>
      </div>
    }

    <!-- Substitution Form -->
    <form [formGroup]="formGroup" (ngSubmit)="onSubmit()" class="substitute-form">
      <!-- New Payment Method Selection -->
      <div class="form-row">
        <mat-form-field appearance="outline" class="w-full">
          <mat-label>Nouveau mode de règlement</mat-label>
          <mat-select formControlName="newMethod" required>
            @for (method of paymentMethods; track method.id) {
              <mat-option [value]="method.id">
                {{ method.name }}
              </mat-option>
            }
          </mat-select>
          <mat-error *ngIf="formGroup.get('newMethod')?.hasError('required')"> Veuillez sélectionner le nouveau mode de règlement. </mat-error>
        </mat-form-field>
      </div>

      <!-- Conditional Metadata: Check (id: 3) -->
      @if (selectedMethodId === 3) {
        <div class="form-row split">
          <mat-form-field appearance="outline" class="flex-1">
            <mat-label>Numéro de chèque</mat-label>
            <input matInput formControlName="checkNumber" placeholder="Ex: 1234567" required />
            <mat-error *ngIf="formGroup.get('checkNumber')?.hasError('required')"> Numéro de chèque obligatoire. </mat-error>
          </mat-form-field>
          <mat-form-field appearance="outline" class="flex-1">
            <mat-label>Établissement bancaire</mat-label>
            <input matInput formControlName="bankName" placeholder="Ex: BNP Paribas" />
          </mat-form-field>
        </div>
      }

      <!-- Conditional Metadata: CB (id: 1) -->
      @if (selectedMethodId === 1) {
        <div class="form-row">
          <mat-form-field appearance="outline" class="w-full">
            <mat-label>Référence transaction / carte (optionnel)</mat-label>
            <input matInput formControlName="cardRef" placeholder="Ex: Trans 894520" />
          </mat-form-field>
        </div>
      }

      <!-- Conditional Metadata: Virement (id: 6) -->
      @if (selectedMethodId === 6) {
        <div class="form-row">
          <mat-form-field appearance="outline" class="w-full">
            <mat-label>Référence virement</mat-label>
            <input matInput formControlName="transferRef" placeholder="Ex: VIR-2026-99" />
          </mat-form-field>
        </div>
      }

      <!-- Mandatory Justification / Reason -->
      <div class="form-row">
        <mat-form-field appearance="outline" class="w-full">
          <mat-label>Motif de la rectification (Audit JET obligatoire)</mat-label>
          <textarea matInput rows="2" formControlName="reason" placeholder="Ex: Erreur de sélection de touche lors de l'encaissement" required></textarea>
          <mat-hint>Minimum 5 caractères requis pour la traçabilité fiscale.</mat-hint>
          <mat-error *ngIf="formGroup.get('reason')?.hasError('required')"> Le motif de rectification est obligatoire. </mat-error>
          <mat-error *ngIf="formGroup.get('reason')?.hasError('minlength')"> Le motif doit comporter au moins 5 caractères. </mat-error>
        </mat-form-field>
      </div>
    </form>
  </mat-dialog-content>

  <!-- Dialog Actions -->
  <mat-dialog-actions class="dialog-actions">
    <button type="button" class="custom-button secondary" (click)="onCancel()" [disabled]="isSubmitting"> Annuler </button>
    <button type="button" class="custom-button success" (click)="onSubmit()" [disabled]="formGroup.invalid || isSubmitting">
      @if (isSubmitting) {
        <mat-spinner diameter="18" class="button-spinner"></mat-spinner>
        <span>Validation en cours...</span>
      } @else {
        <mat-icon>check_circle</mat-icon>
        <span>Valider la rectification</span>
      }
    </button>
  </mat-dialog-actions>
</div>
